// get data from external database and save to store

import firebase from "firebase/app";
import "firebase/firestore";
import { mapGetters } from "vuex";
// import getFacilities from "@/register/facility/mixins/getFacilities.js";
// import countersFunctions from "@/support/stats/mixins/countersFunctions.js";

export default {
  data() {
    return {};
  },
  // mixins: [getFacilities, countersFunctions],
  computed: {
    ...mapGetters(["getAppStatus", "getComp", "getFacility", "getCurrentPage"])
  },
  methods: {
    getCompThenSaveToStore(cid) {
      const db = firebase.firestore();
      // eslint-disable-next-line
      db.collection("company").doc(cid)
        .get()
        .then(doc => {
          this.$store.dispatch("changeCompany", doc.data());
        });
    },
    getCompThenGoToCompReadPage(cid) {
      const db = firebase.firestore();
      // eslint-disable-next-line
      db.collection("company").doc(cid)
        .get()
        .then(doc => {
          this.enableSpinner = false;
          this.enableSpinner2 = false;
          this.$store.dispatch("changeComp", doc.data());
          this.setLocalCompanyCounters();
          if (this.getAppStatus.previousPage === "/facilityregister") {
            // do nothing just reappear
          } else {
            if (this.getCurrentPage === "/welcomestart") {
              // do nothing
            } else {
              this.$router.push("/compread");
            }
          }
        });
    },
    getCompThenGoToFacilityRegisterPage(cid) {
      const db = firebase.firestore();
      // eslint-disable-next-line
      db.collection("company").doc(cid)
        .get()
        .then(doc => {
          this.enableSpinner = false;
          this.enableSpinner2 = false;
          this.enableSpinner3 = false;
          this.$store.dispatch("changeComp", doc.data());
          if (this.getAppStatus.previousPage === "/facilityregister") {
            // do nothing just reappear
            this.getFacilitiesFromComp();
          } else {
            this.getFacilitiesFromComp();
            this.$router.push("/facilityregister");
          }
        });
    },
    getFacilityThenGoToFacilityReadPage(fid) {
      const db = firebase.firestore();
      // eslint-disable-next-line
      db.collection("facility").doc(fid)
        .get()
        .then(doc => {
          this.enableSpinner = false;
          this.enableSpinner2 = false;
          this.enableSpinner3 = false;
          this.$store.dispatch("changeFacility", doc.data());
          this.setLocalFacilityCounters();
          this.$router.push("/facilityread");
        });
    },
    getFacilityReload(fid) {
      const db = firebase.firestore();
      // eslint-disable-next-line
      db.collection("facility").doc(fid)
        .get()
        .then(doc => {
          this.enableSpinner = false;
          this.enableSpinner2 = false;
          this.enableSpinner3 = false;
          this.$store.dispatch("changeFacility", doc.data());
        });
    },
    getAssetThenGoToAssetReadPage(aid) {
      this.enableSpinner = true;
      this.enableSpinnerGetAsset = true;
      // console.log("getAsset");
      // console.log(aid);
      const db = firebase.firestore();
      // eslint-disable-next-line
      db.collection("asset").doc(this.getUser.pref.select.cname).collection(this.getUser.select.fname).doc(aid)
        .get()
        .then(doc => {
          this.enableSpinner = false;
          this.enableSpinner2 = false;
          this.enableSpinner3 = false;
          this.enableSpinnerGetAsset = false;
          this.$store.dispatch("changeAsset", doc.data());
          this.$router.push("/assetread");
        });
    },
    getAssetDataOnly(aid) {
      this.enableSpinner = true;
      const db = firebase.firestore();
      // eslint-disable-next-line
      db.collection("asset").doc(this.getUser.pref.select.cname).collection(this.getUser.select.fname).doc(aid)
        .get()
        .then(doc => {
          this.$store.dispatch("changeAsset", doc.data());
        });
    },
    getFacilityThenSaveToStore(fid) {
      const db = firebase.firestore();
      // eslint-disable-next-line
      db.collection("facility").doc(fid)
        .get()
        .then(doc => {
          this.enableSpinner = false;
          this.$store.dispatch("changeFacility", doc.data());
          // this.$router.push("/facilityread");
        });
    },
    getCompUnderReview(cid) {
      const db = firebase.firestore();

      db.collection("company")
        .where("basic.cid", "==", cid)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.enableSpinner = false;
            this.changeCompReviewBtnDisabled = false;
            this.$store.dispatch("changeCompReview", doc.data());
          });
        });
    },
    getFacilityUnderReview(fid) {
      const db = firebase.firestore();

      db.collection("facility")
        .where("basic.fid", "==", fid)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.enableSpinner = false;
            this.getDetailBtnDisabled = false;
            this.$store.dispatch("changeFacilityReview", doc.data());
          });
        });
    },
    getUserWithDID(userDID) {
      const db = firebase.firestore();
      // eslint-disable-next-line
      db.collection("user").doc(userDID)
        .get()
        .then(doc => {
          this.enableSpinner = false;
          this.$store.dispatch("changeUser", doc.data());
        });
    },
    getUserCompAccesswithDID(userDID) {
      const db = firebase.firestore();
      let tempUser = this.getUser;
      // eslint-disable-next-line
      db.collection("user").doc(userDID)
        .get()
        .then(doc => {
          this.enableSpinner = false;
          tempUser.access.app.comp = doc.data().access.app.comp;
          this.$store.dispatch("changeUser", tempUser);
        });
    },
    getUserFacilityAccesswithDID(userDID) {
      const db = firebase.firestore();
      let tempUser = this.getUser;
      // eslint-disable-next-line
      db.collection("user").doc(userDID)
        .get()
        .then(doc => {
          this.enableSpinner = false;
          tempUser.access.app.facty = doc.data().access.app.facty;
          this.$store.dispatch("changeUser", tempUser);
        });
    },
    getUserUnderReviewWithEmail(u) {
      // console.log("getUserUnderReviewWithEmail")
      const db = firebase.firestore();
      db.collection("user")
        .where("cont.email", "==", u)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.enableSpinner = false;
            this.$store.dispatch("changeUserReview", doc.data());
          });
        });
    },
    getUserUnderReviewWithDID(did) {
      const db = firebase.firestore();
      db.collection("user")
        .where("basic.did", "==", did)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.enableSpinner = false;
            this.$store.dispatch("changeUserReview", doc.data());
          });
        });
    }
  }
};
